<h3 class="p-mb-0">E-faktura händelser</h3>
<p-table class="p-col-12" [value]="events" responsiveLayout="scroll">
  <ng-template pTemplate="header">
    <tr>
      <th>Tid</th>
      <th>Bilaga</th>
      <th>Status</th>
    </tr>
  </ng-template>
  <ng-template pTemplate="body" let-event>
    <tr>
      <td>{{ event.created }}</td>
      <td>
        <a
          *ngIf="event.signedUrl"
          [href]="event.signedUrl"
          target="_blank"
          class="p-d-flex p-ai-center"
        >
          <i class="pi pi-file p-mr-1" *ngIf="event.signedUrl"></i>
          Visa bilaga</a
        >
      </td>
      <td>
        {{
          crediflowStatusTranslations[event.status] ||
            crediflowStatusTranslations[CrediflowStatus.IN_QUEUE]
        }}
      </td>
    </tr>
  </ng-template>
  <ng-template pTemplate="emptymessage">
    <tr>
      <td colspan="2" class="p-text-center">
        Inga händelser har registrerats ännu.
      </td>
    </tr>
  </ng-template>
</p-table>
